<template>
  <yd-cell-group>
    <yd-cell-item type="label">
      <span slot="left">手机号</span>
      <span slot="right">{{storage.mobile_phone}}</span>
    </yd-cell-item>
    <yd-cell-item arrow type="link" :href="'/'+$route.params.id+'/change-password'">
      <span slot="left">修改密码</span>
    </yd-cell-item>
  </yd-cell-group>
</template>

<script type="text/babel">
export default {
  name: 'setting',
  data () {
    return {
      storage: localStorage
    }
  },
  methods: {
    HistoryBack () {
      window.history.back()
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
  .yd-cell-box
    margin-bottom: 0.5rem
  .default
    color: red
  .order_section
    overflow: hidden
    margin-bottom: 0.4rem
    padding-bottom: .2rem
    background-color: #fff
    border-radius: .2rem
  .order_section .yd-flexbox
    padding: 0.2rem 0.4rem
  .order_section .yd-flexbox.order_number
    border-bottom: 1px solid #dcdcdc
    font-size: 0.32rem
    color: #333
    position: relative
    padding-top: .3rem
    padding-bottom: .2rem
  .number
    color: #999
    text-align: end
    font-size: .28rem
  .status_now
    color: #999
    text-align: end
    font-size: .28rem
    position: relative
  .status_pay
    width: .2rem
    height: .2rem
    background-color: #00C800
    float: right
    margin-right: .16rem
    margin-top: .1rem
  .status_unpay
    width: .2rem
    height: .2rem
    background-color: red
    float: right
    margin-right: .16rem
    margin-top: .1rem
  .order_section .yd-flexbox.ticket_text
    color: #333
    padding-bottom: 0
    position: relative
  .order_section .title
    font-size: 0.32rem
    color: #00c800
    font-weight: bold
    text-align: left
    width: 100%
    overflow: hidden
  .order_section .admission .yd-flexbox
    padding-left: 0
    padding-right: 0
    color: #999
    padding-top: 0
  .order_section .admission_right
    text-align: right
  .order_name .box
    width: 100%
    overflow: hidden
  .order_name p
    width: 50%
    float: left
    text-align: center
  .state_section
   font-size: 0.32rem
   color: #00c800
   font-weight: bold
   text-align: left
   width: 100%
   overflow: hidden
   position: relative
   margin-top: .2rem
  .order_section .yd-flexbox.state_section
    padding-top: 0.2rem
  .state_time
    padding-top: 0!important
    color: #909090
  .state_time span
    float: right
    color: #909090
  .left_btn_box .yd-btn
    display: block
    float: left
    height: 0.6rem
    width: 1.56rem
    color: #909090
    border-radius: .3rem
    text-align: center
    border: solid .02rem #909090
    background-color: #fff
    box-sizing: border-box
  .left_btn_box>:first-child
  .right_btn_box>:last-child a
    margin-right: calc((200% - 6.24rem) / 3)
  .right_btn_box a
    display: block
    float: right
    height: 0.6rem
    width: 1.56rem
    color: #909090
    border-radius: .3rem
    text-align: center
    font-size: .24rem
    line-height: 0.6rem
    border: solid .02rem #909090
    background-color: #fff
  .order_amount
    color: red
  .yd-flexview
    background: none!important
  .order_number .yd-flexbox-item
    padding: 0
  .clearfix
    clear: both
  .header_top
    background: url(../../assets/image/single-my-bg.png)
    background-repeat: no-repeat
    background-size: cover
    padding-top: 1rem
    padding-bottom: .6rem
    border-bottom-left-radius: 10%
    border-bottom-right-radius: 10%
  .header p
    text-align: center
    color: #fff
  .user_name p
  .user_name button
    font-size: .24rem
    color: #fff
    line-height: .32rem
    font-family:"microsoft yahei"
    vertical-align: baseline
  .user_name
    margin-bottom: .1rem
  .head a
    color: #fff
  .head
    width: 1.8rem
    height: 1.8rem
    border: solid .04rem #fff
    border-radius: 50%
    box-sizing: border-box
    margin: 0 auto
    margin-bottom: .2rem
    text-align: center
    line-height: 1.8rem
  .order_status
    width: calc(100% - .4rem)
    margin: 0 auto
    margin-top: -.4rem
    margin-bottom: .2rem
    padding: .2rem 0
    background-color: #fff
    border-radius: .1rem
  .status
    width: calc(100% / 3)
    float: left
    text-align: center
    color: #666
    font-size: .32rem
    line-height: .4rem
    border-right: solid 1px #eee
  .status:nth-child(3)
    border: none
  .status p
    color: #333
  .order_number::before
    content: ""
    width: .06rem
    height: .32rem
    background-color: #00c800
    position: absolute
    left: .2rem
    top: .34rem
    margin-top: .04rem
  .order_section .title
    margin-bottom: .2rem
  .effective_period
    float: right
  .order_number .payment
    float: right
  .info_box
    background-color: rgb(37, 164, 187)
    line-height: .52rem
    color: #fff
</style>



// WEBPACK FOOTER //
// src/views/template1/setting.vue